/**
 * Home's legacy dashboard mock arrays (src/data.js's RECOMMENDED /
 * TRENDING_BOOKS / RECENTLY_READ) carry no stable id — components there
 * key by title only. This resolves such a book to a real catalog id when
 * its title already exists in the local catalog (most of them do — "Fourth
 * Wing", "Yellowface", "The Silent Patient", "Project Hail Mary" all do),
 * or mints a `mock_<slug>` id otherwise, which useBookDetails then falls
 * back to hydrating via an Open Library title+author search.
 */

import { getAllCatalogBooks } from '@/lib/localBookCatalog';

function slugify(str) {
  return String(str)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

export function resolveMockBookId({ title, author } = {}) {
  if (!title) return null;
  const match = getAllCatalogBooks().find((b) => b.title.toLowerCase() === title.toLowerCase());
  if (match) return match.id;
  const authorSlug = author ? `_${slugify(author)}` : '';
  return `mock_${slugify(title)}${authorSlug}`;
}
